import http from '@/services/Http/http'
import { BusinessException, TechnicalException } from './ErrorHandler'

export default {
  async requestEnvelope (envelopeRequest) {
    try {
      let params = {
        version: '3'
      }
      let formdata = envelopeRequest
      let response = await http.Envelope.post(`envelopes`, formdata, { params })
      return response.data
    } catch (e) {
      if (e.response.status >= 400 && e.response.status < 500 && !!e.response.data.message) {
        throw new BusinessException(e.response.data.code, e.response.data.message)
      } else {
        if (!!e.response.data && !!e.response.data.message) {
          e.message = `${e.message} - ${e.response.data.message}`
        }
        throw new TechnicalException(e)
      }
    }
  },
  async cancelEnvelope (envelopeId) {
    try {
      let params = {
        version: '3'
      }
      let response = await http.Envelope.put(`envelopes/${envelopeId}/cancel`, {}, { params })
      return response.data
    } catch (e) {
      if (e.response.status >= 400 && e.response.status < 500 && !!e.response.data.message) {
        throw new BusinessException(e.response.data.code, e.response.data.message)
      } else {
        if (!!e.response.data && !!e.response.data.message) {
          e.message = `${e.message} - ${e.response.data.message}`
        }
        throw new TechnicalException(e)
      }
    }
  },
  async getAllEnvelopes (page = 0, pageSize = 5, status = 'all') {
    try {
      let params = {
        version: '3',
        page: page,
        pageSize: pageSize,
        status: status
      }
      let response = await http.Envelope.get(`envelopes`, { params })
      return {
        items: response.data,
        totalCount: Number(response.headers['x-totalcount'])
      }
    } catch (e) {
      throw new TechnicalException(e)
    }
  }
}
